import React from 'react';
import Breadcrumbs from 'Components/Breadcrumbs';

import NavActions from 'Services/Navigation/Actions';

interface CartBreadcrumbsProps {
    currentItem: number;
}

const CartBreadcrumbs = (props: CartBreadcrumbsProps): JSX.Element => {
    const { currentItem } = props;

    const data = [
        {
            key: '1',
            label: 'Shipping Address',
            disabledNumber: currentItem < 1,
            disabledLine: currentItem === 1,
            onClick: () => NavActions.navToShippingAddress(),
        }, {
            key: '2',
            label: 'Order Review',
            disabledNumber: currentItem < 2,
            disabledLine: currentItem === 1 || currentItem === 2,
            onClick: () => NavActions.navToOrderReview(),
        },
        {
            key: '3',
            label: 'Payment',
            disabledNumber: currentItem < 3,
            onClick: () => NavActions.navToPayment(),
        },
    ];

    return (
        <Breadcrumbs items={data} />
    );
};

export default CartBreadcrumbs;
